import { render, staticRenderFns } from "./BukuBesarPembantu.vue?vue&type=template&id=6cb90aa5&"
import script from "./BukuBesarPembantu.vue?vue&type=script&lang=js&"
export * from "./BukuBesarPembantu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports